
import CatalogSearchSection from "../../../common/catalog/CatalogSearchSection";

export default function SearchSection({ initQuery, onSearch }) {
	return (
		<CatalogSearchSection
			title="جستجو در وبینارها"
			placeholder="نام وبینار"
			initQuery={initQuery}
			onSearch={onSearch}
		/>
	);
}
